import { createStorage } from './createStorage';

const isWebViewStorage = createStorage<boolean>({
  key: 'isWebView',
  fallback: false,
  area: 'session',
});

export const setIsWebView = (): void => {
  const displayMode = new URLSearchParams(window.location.search).get(
    'displaymode',
  );
  if (displayMode) {
    isWebViewStorage.set(displayMode === 'app');
  }
};

export const isWebView = (): boolean => isWebViewStorage.get();
